import { getValidationSchema } from '../../../../../../../form/common.validators';
import { PARAMS_STEP_AUTH_VALIDATION_FIELDS, PARAMS_STEP_FIELDS } from './step1.config';

export const schema = (isLoggedIn: boolean) =>
    getValidationSchema(isLoggedIn ? PARAMS_STEP_FIELDS : PARAMS_STEP_AUTH_VALIDATION_FIELDS);
